module.exports = __webpack_public_path__ + "static/media/minus.35ce704a.svg";